// test1834
(1834 && 0);
